import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../cn.js";
/** Renders a document template's HTML in an isolated frame (A4 aspect) for preview before issuing. */
export function DocumentPreview({ html, title, className }) {
    return (_jsx("div", { className: cn("overflow-hidden rounded-md border border-line bg-tint p-3", className), children: _jsx("iframe", { title: title, srcDoc: html, sandbox: "", className: "aspect-[210/297] w-full rounded-sm bg-white shadow-soft" }) }));
}
//# sourceMappingURL=DocumentPreview.js.map